import React, { useEffect } from "react";
import SelectComponent from "./SelectComponent";
import { useLocation } from "react-router-dom";
import Select from "react-select";

function NewLeadSelect({
  leadSourceOptions,
  leadPipelineOptions,
  businessCategoryOptions,
  partnerOptions,
  shipmentPotentialOptions,
  clientPersonaOptions,
  // handleCheckboxChange7,
  employeeId,
  isKycDone,
  employee,
  utmSourceOptions,
  utmMediumOptions,
  utmCampaignOptions,
  filterByObj,
  setFilterByObj,
  onFilterChange,
  handleCheck,
}) {
  const location = useLocation();

  const leadSourceReport = location.state?.leadSource;
  const salesAgentByReport = location.state?.salesAgent;
  const salesAgentNameByReport = location.state?.salesAgentName;

  // Handlers (NO LOCAL STATE)
  const handleChange = (key, selectedOptions, isId = false) => {
    // console.log("SELECTED OPTIONS:", selectedOptions);
    let values = [];

    if (selectedOptions) {
      values = isId
        ? selectedOptions.map((opt) => opt.id)
        : selectedOptions.map((opt) => opt.value);
    }

    onFilterChange({ [key]: values });
  };

  // Report based auto filter
  useEffect(() => {
    if (leadSourceReport) {
      onFilterChange({ filterByLeadSource: leadSourceReport });
    }
  }, [leadSourceReport]);

  useEffect(() => {
    if (salesAgentByReport || salesAgentNameByReport) {
      const agentArray = Array.isArray(salesAgentByReport)
        ? salesAgentByReport
        : salesAgentByReport
          ? [salesAgentByReport]
          : [];

      onFilterChange({ filterByEmployeeId: agentArray });
    }
  }, [salesAgentByReport, salesAgentNameByReport]);

  const employeeOptions = employeeId?.map((emp) => ({
    name: emp.name, // IMPORTANT (SelectComponent expects name)
    id: emp.id,
  }));

  const handleCheckboxChange7 = (selectedOptions) => {
    const ids = selectedOptions ? selectedOptions.map((opt) => opt.id) : [];

    const names = selectedOptions
      ? selectedOptions.map((opt) => opt.value) // value = name
      : [];

    onFilterChange({ filterByEmployeeId: ids }); // API
  };

  const getSelectedOptions = (options, selectedValues) => {
    if (!Array.isArray(selectedValues)) return [];

    return options.filter(opt =>
      selectedValues.includes(opt.value)
    );
  };


  const normalize = (v) => v?.trim();

  const handleUtmSourceChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map(opt => normalize(opt.value))
      : [];

    onFilterChange({ utmSource: values });
  };

  // const handleUtmSourceChange = (selectedOptions) => {
  //   const values = selectedOptions
  //     ? selectedOptions.map(opt => opt.name)
  //     : [];

  //   onFilterChange({ utmSource: values });
  // };






  return (
    <>
      <SelectComponent
        label="Lead Source"
        options={leadSourceOptions}
        handleSelectChange={(opt) => handleChange("filterByLeadSource", opt)}
        selectedOptions={filterByObj.leadSource || []}
      />

      <SelectComponent
        label="Lead Pipeline"
        options={leadPipelineOptions}
        handleSelectChange={(opt) => handleChange("filterByLeadPipeline", opt)}
        selectedOptions={filterByObj.leadPipeline || []}
      />

      <SelectComponent
        label="Business Category"
        options={businessCategoryOptions}
        handleSelectChange={(opt) =>
          handleChange("filterByBusinessCategory", opt)
        }
        selectedOptions={filterByObj.businessCategory || []}
      />

      <SelectComponent
        label="Shipping Partner"
        options={partnerOptions}
        handleSelectChange={(opt) => handleChange("filterByPartner", opt)}
        selectedOptions={filterByObj.partner || []}
      />

      <SelectComponent
        label="Shipment Potential"
        options={shipmentPotentialOptions}
        handleSelectChange={(opt) =>
          handleChange("filterByShipmentPotential", opt)
        }
        selectedOptions={filterByObj.shipmentPotential || []}
      />

      <SelectComponent
        label="Client Persona"
        options={clientPersonaOptions}
        handleSelectChange={(opt) => handleChange("filterByClientPersona", opt)}
        selectedOptions={filterByObj.clientPersona || []}
      />

      {/* <SelectComponent
       label="Lead Owner"
        options={employeeId}
        //  handleSelectChange={handleCheckboxChange7}
        // selectedOptions={filterByEmployeeId}
        selectedOptions={filterByObj.leadOwner || []}
        includeNotAssigned={employee.userType !== "0"}
      /> */}
      <SelectComponent
        label="Lead Owner"
        options={employeeOptions}
        handleSelectChange={handleCheckboxChange7}
        selectedOptions={
          employeeOptions
            ?.filter((emp) => (filterByObj.employeeId || []).includes(emp.id))
            .map((emp) => emp.name) || [] // pass name in this
        }
        includeNotAssigned={employee.userType !== "0"}
      />

      {/* Input Controlled */}
      <div className="col-sm-2 mt-3">
        <label>Minimum Expected Shipment</label>
        <input
          type="search"
          className="form-control"
          placeholder="Minimum Expected Shipment..."
          value={filterByObj.minimumExpectedShipmentToFship || ""}
          onChange={(e) =>
            onFilterChange({
              minimumExpectedShipmentToFship: e.target.value,
            })
          }
        />
      </div>

      <SelectComponent
        label="KYC"
        options={isKycDone}
        handleSelectChange={(opt) => handleChange("filterByIskycDone", opt)}
        selectedOptions={filterByObj.isKycDone || []}
      />

      {/* utm filter */}

      {/* UTM SOURCE */}



      {/* UTM Source */}
      <div className="col-sm-2 mt-3" >
        <label>UTM Source</label>
        <Select
          isMulti
          options={utmSourceOptions}
          value={filterByObj.utmSource}
          onChange={(selected) => {
            setFilterByObj(prev => ({ ...prev, utmSource: selected }));
          }}
        />
      </div>

      {/* UTM Medium */}
      <div className="col-sm-2 mt-3">
        <label>UTM Medium</label>
        <Select
          isMulti
          options={utmMediumOptions}
          value={filterByObj.utmMedium}
          onChange={(selected) => {
            setFilterByObj(prev => ({ ...prev, utmMedium: selected }));
          }}
        />
      </div>

      {/* UTM Campaign */}
      <div className="col-sm-2 mt-3">
        <label>UTM Campaign</label>
        <Select
          isMulti
          options={utmCampaignOptions}
          value={filterByObj.utmCampaign}
          onChange={(selected) => {
            setFilterByObj(prev => ({ ...prev, utmCampaign: selected }));
          }}
        />
      </div>


      {/* Checkbox Controlled */}
      <div className="col-sm-2 mt-3">
        <input
          type="checkbox"
          id="disableGenericEmail"
          checked={filterByObj.genericEmailPattern || false}
          onChange={(e) => handleCheck(e.target.checked)}
          style={{ marginRight: "5px" }}
        />
        <label htmlFor="disableGenericEmail">Disable Generic Email</label>
      </div>
    </>
  );
}

export default NewLeadSelect;
